PopOver = require 'views/lib/pop-over'
View = require 'view'
SetTagView = require './set-tag-view'

module.exports = class EditTagView extends SetTagView
  getName: ->
    @model.get('name')

  onSubmit: (name) ->
    if name
      @model.update({ name })
      PopOver.popView()
    return

  onDelete: ->
    @model.destroy()
    PopOver.popView()

  viewTitleKey: 'edit tag'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/edit-tag-view.coffee